import React from 'react';
import { UpdateProjectReportError, AddProjectReportError, DeleteProjectReportError } from '@bechtel/types';
import { ApolloError } from '@apollo/client';
import { Trans } from '@lingui/macro';

export const getError = (error) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured. Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateProjectReportError.MISSING_REQUIRED_PERMISSION:
    case AddProjectReportError.MISSING_REQUIRED_PERMISSION:
    case DeleteProjectReportError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission for the reports. Please click close button and try again.</Trans>;
    case UpdateProjectReportError.NOTHING_TO_UPDATE:
      return <Trans>Report not updated. Please click close button and try again.</Trans>;
    case AddProjectReportError.ADD_REPORT_ERRORED:
      return <Trans>Report not added. Please click close button and try again.</Trans>;
    case AddProjectReportError.MISSING_REPORT_NAME:
      return <Trans>Report Name missing.</Trans>;
    case AddProjectReportError.MISSING_REPORT_POWERBI_URL:
      return <Trans>Report Power BI url missing.</Trans>;
    case AddProjectReportError.REPORT_NAME_EXISTS:
      return <Trans>Report name already taken. Please try other name for report.</Trans>;
    case UpdateProjectReportError.UPDATE_REPORT_ERRORED:
      return <Trans>Report not updated. Please click close button and try again.</Trans>;
    case DeleteProjectReportError.DELETE_REPORT_ERRORED:
      return <Trans>Report not deleted. Please click close button and try again.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};
